module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createWebhookDialog.events.successfulUpdates":"Successfully updated the webhook \u0027{webhookName}\u0027"}}')
  delete Component.options._Ctor
}
